import {APPROVAL_STATUS} from '../../../../constants';

export const hasLockedInternalTime = timeReg => {
	const idleTime = timeReg.idleTime;
	const isInternalTime = idleTime?.isInternalTime;
	const approvalStatus = timeReg?.approvalStatus;

	return isInternalTime && [APPROVAL_STATUS.SUBMITTED, APPROVAL_STATUS.APPROVED].includes(approvalStatus);
};

// `viewer` is accepted as a future FF-aware extension point; the lock condition itself is currently FF-agnostic.
export const canEditTimeReg = (row, viewer) => {
	if (!row) return false;
	const status = row.approvalStatus;
	if (status == null) return true;

	if (status === APPROVAL_STATUS.INVOICED) return false;

	const isIdle = row.idleTimeId != null || row.idleTime != null;
	if (isIdle && (status === APPROVAL_STATUS.SUBMITTED || status === APPROVAL_STATUS.APPROVED)) {
		return true;
	}

	if (status === APPROVAL_STATUS.SUBMITTED || status === APPROVAL_STATUS.APPROVED) {
		return false;
	}

	// Falls through to editable for PENDING and DECLINED, regardless of FF, matching
	// shouldBypassPersonLockDate in TimeRegLogic.java.
	//
	// That backend check used to gate the DECLINED case on the FF, on the reasoning that the
	// transitions producing a declined row are themselves FF-gated so no such row could exist
	// while the FF was off. The first half is true; the conclusion is not. Approval status is
	// never rewritten when the FF is turned off, so rows declined while it was on survive the
	// rollback — and gating the bypass froze them, since they sit inside the owner's own submit
	// lock and RESUBMIT is rejected without the FF. Being FF-agnostic here was right, and the
	// backend now agrees.
	return true;
};

export const timeEntryLockedInternalTime = (lineItem, dayRegs, isWeekView) => {
	const timeReg = lineItem.timeReg ? (lineItem.timeReg.node ? lineItem.timeReg.node : lineItem.timeReg) : lineItem;

	return isWeekView
		? dayRegs && dayRegs.length > 0 && dayRegs.some(tReg => hasLockedInternalTime(tReg.node))
		: hasLockedInternalTime(timeReg);
};

// Mirrors timeEntryLockedInternalTime's week/day-view normalization, but delegates the lock
// condition to canEditTimeReg (broader than hasLockedInternalTime: fires on SUBMITTED/APPROVED
// non-idle regardless of internal-time flag, plus INVOICED).
export const timeEntryEditable = (lineItem, dayRegs, isWeekView, viewer) => {
	const timeReg = lineItem.timeReg ? (lineItem.timeReg.node ? lineItem.timeReg.node : lineItem.timeReg) : lineItem;

	return isWeekView
		? !(dayRegs && dayRegs.length > 0) || dayRegs.every(tReg => canEditTimeReg(tReg.node, viewer))
		: canEditTimeReg(timeReg, viewer);
};
